import { NotFoundRoute } from "@tanstack/react-router";
import { NotFound404 } from "../components/not-found-404";
import { rootRoute } from "./root";

export const notFoundRoute = new NotFoundRoute({
  getParentRoute: () => rootRoute,
  component: () => <NotFound404 />,
});
